import { IWorksFolder } from '../pages/h5_self_service/typing';
import {
  IWorksFolderList,
  IWorksFolderListItem,
} from '../typings/listResource';

export function transToWorksDataList(
  data: IWorksFolderListItem[]
): IWorksFolder[] {
  if (!data || data.length === 0) {
    return [];
  }
  const _data = data?.map((item: IWorksFolderListItem) => {
    return {
      id: item.id,
      name: item.title,
      fileSuffix: item.fileSuffix,
      tagsGroup: {
        category:
          item.rootTitle && item.rootId
            ? {
                name: item.rootTitle,
                id: item.rootId,
              }
            : undefined,
        age: transAgeToString(item.ages),
        tags: item.tags,
      },
      description: item.intro,
      fileList: [],
      imageUrl: item.imageUrl, // 封面图
      childCnt: item.childCnt, // 作品数量
      type: item.type, // 类型
      status: item.status,
      needCapacityMb: item.needCapacityMb,
      updateTime: item.updateTime,
      fileSizeMb: item.fileSizeMb,
      // items: item.items && transToWorksDataList(item.items), // 二级目录
    };
  });

  return _data;
}

export function transToWorksData(data: IWorksFolderList): IWorksFolder {
  return {
    id: data.id,
    name: data.title,
    fileSuffix: data.fileSuffix,
    tagsGroup: {
      category:
        data.rootTitle && data.rootId
          ? {
              name: data.rootTitle,
              id: data.rootId,
            }
          : undefined,
      age: transAgeToString(data.ages),
      tags: data.tags,
    },
    description: data.intro,
    fileList: [],
    imageUrl: data.imageUrl, // 封面图
    childCnt: data.childCnt, // 作品数量
    useId: data.userId, // 用户ID
    type: data.type, // 类型
    rootId: data.rootId,
    status: data.status,
    items: data.items && transToWorksDataList(data.items), // 二级目录
    updateTime: data.updateTime,
    fileSizeMb: data.fileSizeMb,
    words: data.words,
    content: data.content,
    quizCnt: data.quizCnt,
  };
}

export function transAgeToString(age: string | number[] | undefined) {
  let result = '';
  
  if (typeof age === 'string') {
    // 处理逗号分隔的字符串格式，如 "4,5,6"
    if (age.includes(',')) {
      const ageArray = age.split(',').map(item => item.trim());
      if (ageArray.length > 1) {
        result = ageArray[0] + '-' + ageArray[ageArray.length - 1];
      } else {
        result = ageArray[0];
      }
    } else {
      result = age;
    }
  } else if (age && age.length) {
    result = age[0] + '-' + age[age.length - 1];
  }

  // 如果有结果且不以"岁"结尾，则添加"岁"字
  if (result && !result.endsWith('岁')) {
    result = result + '岁';
  }
  
  return result;
}
